import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container } from '../ui/common';
import Roll from '../ui/Roll';
import { Section } from './styled';
import ComparisonTable from '../../Common/ComparisonTable';
import list from './data';

function Compare({ header, images }) {
  return (
    <Section>
      <Container>
        <Roll
          title={<FormattedMessage id="model_comparison.title" />}
          startExpanded={false}
        >
          <ComparisonTable images={images} header={header} data={list} />
        </Roll>
      </Container>
    </Section>
  );
}
export default Compare;

Compare.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
  header: PropTypes.arrayOf(PropTypes.any),
};

Compare.defaultProps = {
  images: [],
  header: [],
};
